import React, { useEffect, useState, useMemo, useRef } from "react";
import classes from "../../../assets/styles/Pages/CouponManagement/CouponManagement.module.css";
import { useAtom } from "jotai";
import { loggedInUser, mobileViewCheck } from "../../../utils/store";
import Loader from "../../../components/Loader";
import "react-datepicker/dist/react-datepicker.css";
import { get } from "../../../server";
import { COUPON_DETAILS, EXPORT_COUPON } from "../../../utils/constants/apiUrl";
import showToast from "../../../helpers/showToast";
import { Link, useNavigate } from "react-router-dom";
import DataTable, { createTheme } from "react-data-table-component";
import FormInput from "../../../components/Forms/FormInput";
import searchIcon from "../../../assets/images/global_icons/searchicon.svg";
import { useParams } from "react-router-dom";
import { BsThreeDotsVertical } from "react-icons/bs";
import { saveAs } from "file-saver";
import ShareModal from "../../../components/Modals/ShareModal";
import { Button, Modal, Overlay, Tooltip } from "react-bootstrap";
import { MdClose } from "react-icons/md";
import { GiShare } from "react-icons/gi";
import { QRCode } from "react-qrcode-logo";
import baseUrl from "../../../utils/constants/baseUrl";
import qrCodeLogo from "../../../assets/images/sidebar_icons/logoIcon.png";
import { SHARE_QR } from "../../../utils/constants/common";
import html2canvas from "html2canvas";

const ViewCoupons = () => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [coupons, setCoupons] = useState([]);
  const [shareOpen, setShareOpen] = useState(false);
  const [couponCode, setCouponCode] = useState();
  const [couponCodeImg, setCouponCodeImg] = useState();
  const target = useRef(null);
  const [qrOpen, setQrOpen] = useState(false);
  const [show, setShow] = useState(false);
  let { id } = useParams();
  const navigate = useNavigate();
  const [mobileView] = useAtom(mobileViewCheck);
  const handleFilter = (e) => {
    setFilterText(e.target.value);
  };

  const loadCoupons = async () => {
    setLoading(true);
    const couponId = id;
    const queryString = `?coupon_id=${couponId}`;
    let { status, message, data } = await get(
      COUPON_DETAILS + queryString,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      setCoupons(data.couponCodeText);
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };

  const filteredItems = useMemo(() => {
    const filtered = coupons.filter(
      (item) =>
        `${item.name || ""}`.toLowerCase().includes(filterText.toLowerCase()) ||
        `${item.coupon || ""}`
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        `${item.discount || ""}`.includes(filterText)
    );

    return filtered;
  }, [filterText, coupons]);

  const handleCopy = (code) => {
    navigator.clipboard
      .writeText(code)
      .then(() => {
        showToast(true, "Coupon code copied");
      })
      .catch((error) => {
        showToast(false, "Failed to copy coupon code");
      });
  };

  const handleShareOpen = () => {
    setShareOpen(true);
  };

  const handleShareClose = () => {
    setShareOpen(false);
    setShow(false);
  };
  const handleQrOpen = () => {
    setQrOpen(true);
  };

  const handleQRClose = () => {
    setQrOpen(false);
    setShow(false);
  };

  const exportCoupons = async (filePath) => {
    setLoading(true);
    // const queryString = `?coupon_code_id=${id}`;
    // let { status, message, data } = await get(
    //   id ? EXPORT_COUPON + queryString : EXPORT_COUPON,
    //   Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    // );
    // if (status) {
    //   const filePath = data.path;
    saveAs(filePath, "coupon.docx");
    // } else {
    //   showToast(status, message);
    // }
    setLoading(false);
  };

  createTheme(
    "solarized",
    {
      background: {
        default: "background: var(--secondary_color)",
      },
    },
    "dark"
  );

  const columns = [
    {
      name: "Coupon Code",
      cell: (row) => <p className="globalDetail">{row.coupon}</p>,
    },
    {
      name: "Action",
      right: "true",
      cell: (row) => (
        <div className={`dropstart ${classes.action}`}>
          <button
            className="btn customActionDropdown dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <BsThreeDotsVertical className={"globalVerticalThreeDots"} />
          </button>
          <ul className="customActionDropdownMenu dropdown-menu ">
            <li>
              <button
                className="dropdown-item"
                onClick={() => handleCopy(row.coupon)}
              >
                Copy
              </button>
            </li>
            <li>
              <button
                className="dropdown-item"
                onClick={() => {
                  handleQrOpen();
                  setCouponCode(`${row?.coupon_code_url}`);
                  setCouponCodeImg(row?.qr_code_image);
                }}
              >
                QR Code
              </button>
            </li>
            <li>
              <button
                className="dropdown-item"
                onClick={() => {
                  setCouponCode(`${row?.coupon_code_url}`);
                  handleShareOpen();
                  console.log("row", couponCode);
                }}
              >
                Share
              </button>
            </li>
            <li>
              <button
                className="dropdown-item"
                onClick={() => exportCoupons(row.export_file)}
              >
                Export
              </button>
            </li>
          </ul>
        </div>
      ),
    },
  ];

  useEffect(() => {
    loadCoupons();
  }, []);

  // const handleDownload = () => {
  //   html2canvas(document.querySelector("#qrCodeContainer"), {
  //     useCORS: true, // if you use a logo
  //     backgroundColor: null,
  //     scale: 2, // higher quality
  //   }).then((canvas) => {
  //     const link = document.createElement("a");
  //     link.download = "Coupon-Code-QR.png";
  //     link.href = canvas.toDataURL("image/png");
  //     link.click();
  //   });
  // };

  const handleDownload = () => {
    saveAs(couponCodeImg, "qrcode.png");
  };

  return (
    <>
      {!loading ? (
        <div>
          <div className="page_Header">
            <div className="d-flex justify-content-between align-items-md-center align-items-initial flex-md-row flex-column gap-3 mb-3">
              {/* <p className="pageTitle">
                Coupon Codes <span>({coupons.length})</span>
              </p> */}
              <div className="heading">
                <h1 className="pageTitle">
                  Coupon Codes <span>({coupons.length})</span>
                </h1>
              </div>
              <div className="d-flex align-items-center justify-content-between gap-2">
                {/* <FormInput
                  icon={searchIcon}
                  placeholder="Search..."
                  value={filterText}
                  handleChange={handleFilter}
                /> */}
                <div
                  className="input-group"
                  style={{ maxWidth: "250px", height: "45px" }}
                >
                  <span className="input-group-text bg-white border-end-0">
                    <img
                      src={searchIcon}
                      alt="search"
                      style={{ height: "16px" }}
                    />
                  </span>
                  <input
                    type="text"
                    className="form-control border-start-0"
                    placeholder="Search..."
                    value={filterText}
                    onChange={handleFilter}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className=" default-list-table">
            <DataTable
              columns={columns}
              data={filteredItems}
              pagination
              theme="solarized"
            />
          </div>
          {shareOpen && (
            <>
              {console.log("couponCode", couponCode)}
              <ShareModal
                shareOpen={shareOpen}
                target={target}
                handleShareClose={handleShareClose}
                setShowCopyPopup={setShow}
                functionType="coupon"
                functionUuid={couponCode}
              />
            </>
          )}
          <Overlay
            target={target.current}
            show={show}
            placement={mobileView ? "left" : "right"}
          >
            {(props) => (
              <Tooltip id="overlay-example" {...props}>
                Link Copied
              </Tooltip>
            )}
          </Overlay>
          {qrOpen && (
            <Modal
              show={qrOpen}
              onHide={handleQRClose}
              aria-labelledby="contained-modal-title-vcenter"
              centered
              className="customModal square-modal QRCodeModal"
              size="sm"
            >
              <Modal.Header className="modalHeader flex justify-end">
                <div className="modalGradientCircle"></div>
                <MdClose
                  onClick={handleQRClose}
                  className="modalCloseBtn flex justify-between"
                />
              </Modal.Header>
              <Modal.Body
                style={{ padding: "0" }}
                className="text-center px-4 py-4"
              >
                <div className="d-flex flex-column align-items-center justify-content-center">
                  <div id="qrCodeContainer">
                    {/* <QRCode
                      // value={`${SHARE_QR}coupon${couponCode}`}
                      value={couponCodeImg}
                      // size={256}
                      // bgColor="#ffffff"
                      // fgColor="#000000"
                      crossOrigin="anonymous"
                    /> */}
                    <img
                      src={couponCodeImg}
                      alt="QR Code"
                      style={{ width: "60%", height: "auto" }}
                    />
                  </div>
                  <h5 style={{ margin: "10px" }}>QR Code</h5>
                  <p
                    style={{
                      lineHeight: "18px",
                      marginBottom: "5px",
                      textAlign: "center",
                    }}
                  >
                    Share Or Download Your QR Code
                  </p>
                </div>
                <div className="row justify-content-center mt-3">
                  <div className="col-sm-12 text-center">
                    <Button
                      variant="primary"
                      className="me-3"
                      ref={target}
                      onClick={() => {
                        // setShowCopyPopup(true);
                        // setTimeout(() => {
                        //   setShowCopyPopup(false);
                        // }, 2000);
                        showToast(true, "Link copied to clipboard");
                        navigator.clipboard.writeText(
                          couponCode !== null
                            ? `${SHARE_QR}coupon${couponCode}`
                            : ""
                        );
                      }}
                    >
                      Share QR
                    </Button>
                    {/* <Button variant="primary" onClick={handleDownload}>
                      Download QR
                    </Button> */}
                    {/* <Button
                      variant="primary"
                      onClick={() => downloadImage(couponCodeImg)}
                    >
                      Download QR
                    </Button> */}
                    <Button variant="primary" onClick={handleDownload}>
                      Download QR
                    </Button>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          )}
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default ViewCoupons;
